import React from "react";
import { arrayOf, number, shape, string } from "prop-types";
import styles from "./FederationLoadingView.module.styl";
import { Card } from "uikit/components";
import FederationLoadingRow from "../FederationLoadingRow/FederationLoadingRow";

export default function FederationLoadingView({ sportObjectLoadings }) {
    return (
        <Card borderRadius={"giant"} padding={"none"} className={styles.form}>
            <div className={styles.headingContainer} data-test-name="federation_loading_view">
                <div className={styles.buildingName}>Название спортивного объекта</div>
                <div className={styles.loading}>Загруженность</div>
            </div>
            <div>
                {sportObjectLoadings?.map((item) => (
                    <FederationLoadingRow key={item.id} sportObjectLoading={item} />
                )) ?? []}
            </div>
        </Card>
    );
}

FederationLoadingView.propTypes = {
    sportObjectLoadings: arrayOf(
        shape({
            id: number.isRequired,
            name: string.isRequired,
            loading: number.isRequired,
        }),
    ),
};
